export default "__VITE_ASSET__BknIHAWH__"